import type { Permission } from '../types';

export const permissionDescriptions: Record<Permission, string> = {
  access_pos: 'Access the Point of Sale screen',
  access_reports: 'View sales and performance reports',
  manage_menu: 'Add, edit, and delete menu items',
  manage_inventory: 'Manage stock levels and inventory items',
  manage_staff: 'Add, edit, and remove staff members',
  manage_tables: 'Manage the restaurant floor plan and tables',
  manage_customers: 'View and manage the customer database',
  manage_loyalty: 'Configure the customer loyalty program',
  manage_purchasing: 'Create and manage purchase orders and suppliers',
  manage_invoices: 'Create supplier and client tax invoices',
  manage_delivery: 'Manage delivery platform integrations',
  manage_settings: 'Access and change system-wide settings',
  view_staff_pins: 'View staff member PINs in staff management',
  view_staff_payroll: 'View staff pay rates and payroll details in staff management',
  test_integrations: 'Test third-party integrations',
  approve_integrations: 'Approve third-party integrations',
  view_integrations: 'View integration settings and status',
};

export const ALL_PERMISSIONS: Permission[] = Object.keys(permissionDescriptions) as Permission[];

